import { createContext } from 'react';

const Context = createContext();
const { Provider, Consumer } = Context;

export { Provider, Consumer };
export default Context;